export default __webpack_public_path__ + "static/media/kfcBorder.fd5d6960.png";